export enum PLAN_CATEGORY {
	MONTHLY_DECLARATIONS = 'monthly_declarations',
	REGULARIZATIONS = 'regularizations',
	ANNUAL_DECLARATIONS = 'annual_declarations',
	ASAT = 'asat',
}
